import * as React from 'react';
import { IAIcon } from '../../../icon/Icon'
import * as styles from './peopleCard.css';
import { Helper } from './../../../../Helper';
import { LocalizationService } from '../../../../services/LocalizationService';
import { MSPersonCard } from '../../../msPersonCard/MSPersonCard';
import { IFontSlots } from '../../../../interfaces/IFontSlots';
import '../../../../styles/BasicIA.css';
import { ENTER_KEY, SPACEBAR_KEY } from '../../../../global/Constants';


interface IPeopleProperty {
  property: string;
  value: string;
  iconTitle?: string;
  iconColor?: string;
  iconSize?: number;
}
interface IPeopleCardProps {
  properties: IPeopleProperty[];
  image?: string;
  userId?: string;
  backgroundColor?: string;
  linkedTextColor?: string;
  index?: number;
  nameLink?: string;
  floatImage?: boolean;
  styles?: React.CSSProperties;
  highlightColor: string;
  todayIcon?: string;
  isToday: boolean;
  cardHeight: number;
  isEditMode?: boolean;
  userLoginName?: string;
  fontSlots?: IFontSlots;
}

interface ICredentialValue {
  value?: string;
  iconTitle?: string;
  iconColor?: string;
  iconSize?: number;
  classNames?: any[];
  link?: string;
}

interface IUserCredentials {
  PREFERREDNAME?: ICredentialValue;
  WORKEMAIL?: ICredentialValue;
  WORKPHONE?: ICredentialValue;
  MOBILEPHONE?: ICredentialValue;
  DEPARTMENT?: ICredentialValue;
  JOBTITLE?: ICredentialValue;
}

export class IAPeopleCard extends React.Component<IPeopleCardProps> {

  assignCredentialsToUser = (properties: IPeopleProperty[]): IUserCredentials => {
    let credentialsUser = {
    };
    properties.map((property) => {
      let linkTo: string;
      if (property.property === "WorkEmail" || property.property === "WorkPhone") { linkTo = `tel:${property.value}` }
      if (property.property) {
        let propertyName = property.property?.toUpperCase();
        Object.defineProperty(credentialsUser, propertyName, {
          value: {
            value: property.value,
            iconTitle: property.iconTitle,
            iconColor: property.iconColor,
            iconSize: property.iconSize,
            classNames: property.property === "PreferredName" ? [styles.IA_credential_name, styles.IA_credentials_dots] : property.property === "Birthday" ? [styles.IA_credentials_dots] : [styles.IA_credentials_dots, styles.IA_credentials_text],
            link: linkTo
          },
          enumerable: true
        });
      }
    })
    return credentialsUser;
  }

  getLink = (parentObject: IUserCredentials, key: string): string => {
    if (parentObject && parentObject[key]) {
      if (parentObject[key] && key === "PREFERREDNAME") {
        return 'PREFERREDNAME';
      } if (parentObject[key] && key === "WORKEMAIL") {
        return `mailto:${parentObject[key].value}`;
      } if (parentObject[key] && key === "MOBILEPHONE" || key === "WORKPHONE") {
        return `tel:${parentObject[key].value}`;
      } if (parentObject[key] && key === "TEAMSCHAT") {
        return `https://teams.microsoft.com/l/chat/0/0?users=${parentObject[key].value}`;
      } else {
        return "";
      }
    } else {
      return undefined;
    }
  }

  render() {
    let textColor: string =
      this.props.backgroundColor != undefined ? Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.backgroundColor, "#ffffff", "#333333") : "#333333";
    textColor = "#333333" != undefined ? "#333333" : textColor;

    let linkColor: string =
      this.props.backgroundColor != undefined && this.props.backgroundColor !== "#ffffff" && this.props.backgroundColor !== "transparent" ? textColor : this.props.highlightColor;

    let credentialElements: JSX.Element[] = [];
    let firstNameChar: string = undefined;
    let lastNameChar: string = undefined;
    let credentialsUser: IUserCredentials;
    if (this.props.properties && this.props.properties.length > 0) {

      credentialsUser = this.assignCredentialsToUser(this.props.properties);
      if (credentialsUser) {
        for (let variable in credentialsUser) {
          let linkTo = this.getLink(credentialsUser, variable);
          if (credentialsUser[variable] !== undefined && credentialsUser[variable] !== null) {
            if (variable === 'PREFERREDNAME') {
              let fullName: string = credentialsUser[variable].value;
              let firstName: string = fullName.split(' ')[0];
              let lastName: string = fullName.split(' ')[fullName.split(' ').length - 1];
              firstNameChar = firstName[0];
              lastNameChar = firstName !== lastName ? lastName[0] : firstName[1];
            }
            credentialElements.push(
              <div className={styles.IA_item} key={`card:${this.props.index}${variable}`}>
                <div className={credentialsUser[variable].classNames ? credentialsUser[variable].classNames.join(' ') : ""}>
                  {linkTo && linkTo !== "PREFERREDNAME" && variable !== "WORKEMAIL" && variable !== "TEAMSCHAT" && linkTo !== "" &&
                    <a href={linkTo}
                      style={{
                        color: linkColor
                      }}
                    >
                      {credentialsUser[variable].value}
                    </a>}
                  {linkTo && variable === "WORKEMAIL" && linkTo !== "" &&
                    <a href={linkTo} target="_blank"
                      style={{
                        color: linkColor
                      }}
                    >
                      {new LocalizationService().strings.Birthday_email}
                    </a>}
                  {linkTo && variable === "TEAMSCHAT" && linkTo !== "" &&
                    <a href={linkTo}
                      style={{
                        color: linkColor
                      }}
                      target="_blank">
                      {new LocalizationService().strings.Birthday_chat}
                    </a>}
                  {(linkTo === "" || linkTo === "PREFERREDNAME") &&
                    <div
                      className={variable === "PREFERREDNAME" ? "" : credentialsUser[variable].classNames.join(' ')}
                      style={variable === "PREFERREDNAME" ? {
                        fontFamily: this.props.fontSlots?.heading?.fontFamily
                      } : {}}
                    >
                      {credentialsUser[variable].value}
                    </div>}
                </div>
              </div>
            )
          }
        }
      }
    }

    const peopleCardName = (
      <div
        className={styles.IA_personaSmallProfileImage}
        style={{
          backgroundImage: `url('${this.props.image ? this.props.image : ""}')`
        }}
      />
    )

    let profilePicture = (
      <div
        className={styles.IA_personaSmallProfileImageWrapper}
        style={{
          backgroundColor: "#333333",
          color: "#ffffff",
          float: !this.props.floatImage || !this.props.floatImage ? "left" : "none",
          marginRight: !this.props.floatImage || !this.props.floatImage ? "25px" : "auto",
          marginLeft: !this.props.floatImage || !this.props.floatImage ? "10px" : "auto",
        }}
      >
        {this.props.isToday && <div className={styles.IA_notificationToday}
          style={{
            backgroundColor: linkColor
          }}>
          <div className={styles.IA_notificationIcon}>
            <IAIcon
              title={this.props.todayIcon ? this.props.todayIcon : "Balloons"}
              size={26}
              color={this.props.highlightColor != undefined ? Helper.getTextColorBasedOnBackgroundColorDarkness(this.props.highlightColor, "#f4f4f4", "#333333") : "#f4f4f4"}
            />
          </div>
        </div>}

        <div className={styles.IA_personaSmallProfileImageText} >
          {firstNameChar + lastNameChar}
        </div>

        {peopleCardName}
      </div>
    );

    return (
      <div
        className={[styles.IA_peopleCard, "IA_OnFocus"].join(" ")}
        tabIndex={0}
        style={{
          cursor: this.props.userLoginName ? "pointer" : "default",
          ...this.props.styles
        }}
        onClick={() => {
          if (this.props.userLoginName) {
            Helper.openProfilePageWithUserId(this.props.userLoginName, this.props.userId);
          }
        }}
        onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
          if ((event.key === ENTER_KEY || event.key === SPACEBAR_KEY) && this.props.userLoginName) {
            event.preventDefault();
            Helper.openProfilePageWithUserId(this.props.userLoginName, this.props.userId);
          }
        }}
      >
        {this.props.isEditMode
          ?
          <>
            {profilePicture}
          </>
          :
          // Only show PersonCard when not in edit mode
          <MSPersonCard
            userLoginName={this.props.userLoginName}
            userProfileImage={this.props.image}
            highlightColor={this.props.highlightColor}
          >
            {profilePicture}
          </MSPersonCard>
        }
        <div className={styles.IA_peopleCard_content}
          style={{
            height: this.props.cardHeight
          }}>
          {credentialElements}
        </div>
      </div>
    );
  }
}            